<template>
<b-navbar toggleable="lg" type="dark" variant="info" :class="['bg-warning', { embedded: this.isEmbed, 'screen-lg': this.onTabletUp }]">
  <b-row>
    <b-col cols="12" class="d-flex">
      <h2 class="header-title">{{ clientName }} Recipe Planning</h2>
    </b-col>
  </b-row>
</b-navbar>
</template>

<script>
import appConfig from '@src/app.config.ES6';
import store from '@state/store';
import environment from '@src/environment';
import { authComputed, mainComputed } from '@state/helpers';
import { primaryNavItemMixin } from 'primaryNavItemMixin';
import PrimaryNavItems from './PrimaryNavItems';

export default {
  mixins: [primaryNavItemMixin],
  components: {
    PrimaryNavItems,
  },
  props: {
    isEmbed: {
      type: Boolean,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...authComputed,
    ...mainComputed,
    primaryNavItems() {
      return this.getPrimaryNavItems();
    },
    clientName() {
      return appConfig ? appConfig.NAME : '';
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.navbar {
  background-color: $color-navbar-bg !important;
  height: 6rem;
  padding: 0.5rem 3rem;

  .logo img {
    margin: 1rem auto;
    width: 75%;
  }

  .header-title {
    color: white;
  }

  .navbar-nav {
    flex-direction: row;
  }

  &.embedded,
  &.screen-lg {
    z-index: 9999;
  }

  &.screen-lg {
    padding-bottom: 1rem;
    padding-top: 1rem;
  }
}
</style>
